<template>
    <div>
        <form @submit.prevent="salvar">
            <dados-edital v-model="licitacao" :editando="editando"
                          :anexosBloqueadosAtivarInativar="anexosBloqueadosAtivarInativar"
                          @onRemoverAnexo="confirmarRemocaoAnexo"
                          @onAtivarAnexo="confirmarAtivacaoAnexo"
                          @onInativarAnexo="confirmarInativacaoAnexo"
                          @onReenviarDocumentosPncp="processarReenvioDocumentosPncp"></dados-edital>
            <div class="az-actions-form mt-0 mr-4" v-if="editando">
                <div class="align-left">
                </div>
                <div class="align-right mb-3">
                    <button class="action-primary" type="submit">Salvar</button>
                </div>
            </div>
        </form>
        <!--confirmacao sair sem salvar-->
        <az-confirm @onConfirm="sairDaTela(nextFunction)" @onDecline="mostrarDialogConfirmarSaida = false"
                    v-if="mostrarDialogConfirmarSaida">
            Existem anexos que não foram salvos. Deseja sair sem salvar?
        </az-confirm>
        <!--confirmacao remover anexo-->
        <az-confirm @onConfirm="remover()"
                    @onDecline="mostrarDialogRemoverAnexo = false"
                    v-if="mostrarDialogRemoverAnexo">
            Tem certeza que deseja remover o anexo?
        </az-confirm>
        <!--confirmacao ativar anexo-->
        <az-confirm @onConfirm="ativar()"
                    @onDecline="mostrarDialogAtivarAnexo = false"
                    v-if="mostrarDialogAtivarAnexo">
            Tem certeza que deseja ativar o anexo?
        </az-confirm>
        <!--confirmacao inativar anexo-->
        <az-confirm @onConfirm="inativar()"
                    @onDecline="mostrarDialogInativarAnexo = false"
                    v-if="mostrarDialogInativarAnexo">
            Tem certeza que deseja inativar o anexo?
        </az-confirm>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import DadosEdital from '../commons/DadosEdital'

    export default {
        name: 'LicitacaoEdicaoEdital',
        $_veeValidate: {
            validator: 'new'
        },
        components: {DadosEdital},
        data() {
            return {
                anexoParaRemover: null,
                anexoParaAlterar: null,
                editando: false,
                licitacaoId: undefined,
                mostrarDialogConfirmarSaida: false,
                mostrarDialogRemoverAnexo: false,
                mostrarDialogAtivarAnexo: false,
                mostrarDialogInativarAnexo: false,
                nextFunction: undefined,
                anexosBloqueadosAtivarInativar: []
            }
        },
        computed: {
            ...mapState(['licitacao', 'loki'])
        },
        beforeRouteUpdate(to, from, next) {
            this.setLicitacaoId(to.params.id)
            this.setEditando(typeof to.query.edicao !== 'undefined')
            next()
        },
        beforeRouteLeave(to, from, next) {
            if (this.possuiAnexosNaoSalvos()) {
                this.confirmarSaidaDaTela(next)
            } else {
                this.sairDaTela(next)
            }
        },
        created() {
            this.desabilitarLoadingGlobal()
            this.setEditando(typeof this.$route.query.edicao !== 'undefined')
        },
        async mounted() {
            this.setLicitacaoId(this.$route.params.id)
            await this.buscarAnexos()
        },
        methods: {
            async atualizarEdital() {
                this.setMensagemLoading('Salvando os dados do edital...')
                await this.atualizarNumeroEdital()
            },
            async atualizarNumeroEdital() {
                if (!this.possuiItens) {
                    await this.atualizarLicitacaoEdital({
                        licitacaoId: this.licitacaoId,
                        licitacao: {
                            numeroEdital: this.licitacao.numeroEdital
                        }
                    })
                }
            },
            async buscarAnexos() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Atualizando listagem de anexos...')
                await this.buscarAnexosLicitacao(this.licitacaoId)
                this.desabilitarLoadingGlobal()
            },
            async buscarLicitacaoPorId() {
                this.habilitarLoadingGlobal()
                this.setMensagemLoading('Sincronizando a licitação...')
                await this.buscarLicitacao(this.licitacao.id)
                this.desabilitarLoadingGlobal()
            },
            confirmarSaidaDaTela(next) {
                this.nextFunction = next
                this.mostrarDialogConfirmarSaida = true
            },
            confirmarRemocaoAnexo(anexo) {
                this.anexoParaRemover = anexo
                this.mostrarDialogRemoverAnexo = true
            },
            confirmarAtivacaoAnexo(anexo) {
                this.anexoParaAlterar = anexo
                this.mostrarDialogAtivarAnexo = true
            },
            confirmarInativacaoAnexo(anexo) {
                this.anexoParaAlterar = anexo
                this.mostrarDialogInativarAnexo = true
            },
            ehArquivoDefinitivo(anexo) {
                return anexo.id
            },
            async inserirAnexos() {
                this.setMensagemLoading('Salvando os anexos do edital...')
                await this.inserirAnexosLicitacao({licitacaoId: this.licitacao.id, anexos: this.loki.uploadedFiles})
                this.$store.commit('SET_UPLOADED_FILES', [])
                if(this.licitacao.publicado){
                  await this.notificarDocumentosEdital(this.licitacao.id)
                }
            },
            isNovosAnexosValidos() {
                let isValido = this.loki.uploadedFiles.length > 0
                this.loki.uploadedFiles.forEach(anexo => {
                    if (!anexo.tipo) {
                        isValido = false
                    }
                })
                return isValido
            },
            possuiAnexosNaoSalvos() {
                return this.loki.uploadedFiles.length > 0
            },
            async remover() {
                try {
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Removendo o anexo...')
                    if (this.ehArquivoDefinitivo(this.anexoParaRemover)) {
                        await this.removerAnexoLicitacao({licitacaoId: this.licitacao.id, anexoId: this.anexoParaRemover.id})
                    } else {
                        this.removerArquivoTemporario(this.anexoParaRemover.uri)
                    }
                    await this.buscarAnexos()
                    await this.buscarLicitacaoPorId()
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                    this.anexoParaRemover = null
                    this.mostrarDialogRemoverAnexo = false
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                    this.mostrarDialogRemoverAnexo = false
                }
            },
            bloquearAtivacaoInativacaoAnexo(anexoId){
              this.anexosBloqueadosAtivarInativar.push(anexoId)
              setTimeout(() => {
                this.anexosBloqueadosAtivarInativar.shift()
              }, 10000)
            },
            async inativar() {
                try {
                    this.bloquearAtivacaoInativacaoAnexo(this.anexoParaAlterar.id)
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Inativando o anexo...')
                    await this.inativarAnexoLicitacao({licitacaoId: this.licitacao.id, anexoId: this.anexoParaAlterar.id})
                    await this.buscarAnexos()
                    await this.buscarLicitacaoPorId()
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                    this.anexoParaAlterar = null
                    this.mostrarDialogInativarAnexo = false
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                    this.mostrarDialogInativarAnexo = false
                }
            },
            async ativar() {
                try {
                    this.bloquearAtivacaoInativacaoAnexo(this.anexoParaAlterar.id)
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Ativando o anexo...')
                    await this.ativarAnexoLicitacao({licitacaoId: this.licitacao.id, anexoId: this.anexoParaAlterar.id})
                    if(this.licitacao.publicado){
                      await this.notificarDocumentosEdital(this.licitacao.id)
                    }
                    await this.buscarAnexos()
                    await this.buscarLicitacaoPorId()
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                    this.anexoParaAlterar = null
                    this.mostrarDialogAtivarAnexo = false
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                    this.mostrarDialogAtivarAnexo = false
                }
            },
            removerArquivoTemporario(uri) {
                const uploadedFiles = this.loki.uploadedFiles
                const fileIndex = uploadedFiles.findIndex(file => file.uri === uri)
                uploadedFiles.splice(fileIndex, 1)
                this.$store.commit('SET_UPLOADED_FILES', uploadedFiles)
            },
            sairDaTela(next) {
                this.$store.commit('SET_UPLOADED_FILES', [])
                this.habilitarLoadingGlobal()
                next()
            },
            async salvar() {
                try {
                    const validado = await this.$validator._base.validateAll()
                    if (!validado) {
                        return
                    }
                    if (this.possuiAnexosNaoSalvos() && !this.isNovosAnexosValidos()) {
                        this.mostrarNotificacaoErro('Informe o tipo dos anexos.')
                        return
                    }
                    this.habilitarLoadingGlobal()
                    await this.atualizarEdital()
                    await this.inserirAnexos()
                    await this.buscarAnexos()
                    await this.buscarLicitacaoPorId()
                    this.mostrarNotificacaoSucessoDefault()
                    this.desabilitarLoadingGlobal()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                }
            },
            setEditando(editando) {
                this.editando = editando
            },
            setLicitacaoId(licitacaoId) {
                this.licitacaoId = licitacaoId
            },
            async processarReenvioDocumentosPncp({ anexosComErro, licitacaoId }) {
                try {
                    this.habilitarLoadingGlobal()
                    this.setMensagemLoading('Reenviando documentos para o PNCP...')
                    const documentosIds = anexosComErro.map(anexo => anexo.id)
                    await this.reenviarDocumentosComErroPncp({ licitacaoId, documentosIds })
                    await this.buscarAnexos()
                    this.mostrarNotificacaoSucesso('Documentos reenviados para o PNCP com sucesso.')
                    this.desabilitarLoadingGlobal()
                } catch (e) {
                    this.desabilitarLoadingGlobal()
                    this.mostrarNotificacaoErro('Erro ao reenviar documentos para o PNCP.')
                }
            },
            ...mapActions([
                actionTypes.ATUALIZAR_EDITAL,
                actionTypes.BUSCAR_ANEXOS_LICITACAO,
                actionTypes.BUSCAR_LICITACAO,
                actionTypes.INSERIR_ANEXOS_LICITACAO,
                actionTypes.REMOVER_ANEXO_LICITACAO,
                actionTypes.ATIVAR_ANEXO_LICITACAO,
                actionTypes.INATIVAR_ANEXO_LICITACAO,
                actionTypes.NOTIFICAR_DOCUMENTOS_EDITAL,
                actionTypes.REENVIAR_DOCUMENTOS_COM_ERRO_PNCP
            ]),
        }
    }
</script>
